export default __webpack_public_path__ + "static/media/arrow_forward_black_24dp.0546e56a.png";